var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"das-select",attrs:{"id":"dasSelect","data-set":_vm.currentSet,"data-zone":_vm.zone}},[_c('div',{staticClass:"zone-display",attrs:{"id":"zoneDisplay"}},[_c('zoneDisplaySvg',{ref:`svgDisplay_${_vm._uid}`})],1),_c('div',{staticClass:"zone-selector",attrs:{"id":"zoneSelector"}},[_c('zoneSelectorSvg',{ref:"svgSelector"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }